
export const Config = {  
    LOCAL:{
        REST_API : 'http://localhost:3003',
        QR_WEB_URL : 'http://localhost:3000',
        tokenizationKeys:"sandbox_d5j3zcpf_f3gwz3xzcfy37xnz",
        APPLE_BUNDLE_ID:"io.appkey.portal",
        APPLE_REDIRECT_URI:"https://portal.appkey.io/signin",
        GOOGLE_CLIENT_ID:"990108157672-ohjd6pa4drjee30spp8dq5l0gslffla0.apps.googleusercontent.com"
    },
    DEV:{
        REST_API : 'https://api-dev.appkey.io',
        QR_WEB_URL : 'https://dev.appkeyid.com',
        tokenizationKeys:"sandbox_d5j3zcpf_f3gwz3xzcfy37xnz",
        APPLE_BUNDLE_ID:"io.appkey.portal",
        APPLE_REDIRECT_URI:"https://portal-dev.appkey.io/signin",
        GOOGLE_CLIENT_ID:"990108157672-ohjd6pa4drjee30spp8dq5l0gslffla0.apps.googleusercontent.com"
    },
    PROD:{
        REST_API : 'https://api.appkey.io',
        QR_WEB_URL : 'https://appkeyid.com',
        tokenizationKeys:"production_pgtdpxgm_nysd7fnxdddcmysz",
        APPLE_BUNDLE_ID:"io.appkey.portal",
        APPLE_REDIRECT_URI:"https://portal.appkey.io/signin",
        GOOGLE_CLIENT_ID:"990108157672-ohjd6pa4drjee30spp8dq5l0gslffla0.apps.googleusercontent.com"
    }
}